// extracted by mini-css-extract-plugin
export default {"counter":"Results__counter-wJE5z","results":"Results__results-UlwTB","total":"Results__total-Kdii_"};